import React from "react";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";

type Props = { children: React.ReactNode };
type State = { hasError: boolean };

export class SidebarErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error("[SidebarErrorBoundary] Sidebar crashed:", error);
    // eslint-disable-next-line no-console
    console.error("[SidebarErrorBoundary] Component stack:", info.componentStack);
    // eslint-disable-next-line no-console
    console.error("[SidebarErrorBoundary] Device info:", {
      viewport: `${window.innerWidth}x${window.innerHeight}`,
      userAgent: navigator.userAgent,
      route: window.location.pathname,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="h-full w-14 shrink-0 border-r border-border bg-card flex flex-col items-center py-4 gap-2">
          <Menu className="h-5 w-5 text-muted-foreground" />
          <Button
            variant="ghost"
            size="sm"
            className="text-xs px-2"
            onClick={() => window.location.reload()}
          >
            Recarregar
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
